import { DeleteButtonProps } from "@/shared/form/button/delete-button/delete-button";
import { useRemoveDynamicAttributeGroup } from "./model/use-remove-dynamic-attribute-group";
import { DeleteGroupButtonView } from "./ui/delete-group-button-view";

type RemoveDynamicAttributeGroupButtonProps = DeleteButtonProps & {
  groupId: string;
  afterSubmit?: () => void;
};

export function RemoveDynamicAttributeGroupButton({
  groupId,
  afterSubmit,
  ...props
}: RemoveDynamicAttributeGroupButtonProps) {
  const { remove } = useRemoveDynamicAttributeGroup({
    afterSubmit,
  });

  return <DeleteGroupButtonView onClick={() => remove(groupId)} {...props} />;
}
